import { Component, ViewChild } from '@angular/core';
import { MenuLayoutComponent } from '../menu-layout/menu-layout.component';
import { SideBarService } from '../../shared/services/common/side-bar.service';
import { AppAuthService } from '../../shared/services/auth/auth.service';
import { UserSessionService } from '../../shared/services/auth/user-session.service';

@Component({
  selector: 'app-toolbar-layout',
  templateUrl: './toolbar-layout.component.html',
  styleUrl: './toolbar-layout.component.scss',
})
export class ToolbarLayoutComponent {
  shwFilter: boolean = false;

  constructor(
    private sidebarService: SideBarService,
    public authService: AppAuthService,
    public userData: UserSessionService

  ) {}

  ngOnInit(): void {
    //console.log(this.userData.getUserInfo().user_name)
  }

  openSidebar() {
    this.sidebarService.showSidebar();
  }

  loadFilter(){
    this.shwFilter = !this.shwFilter;
  }

  loadLogout(){
    this.authService.logoutUser();
  }

  showMenu() {
    this.sidebarService.showMenubar();
  }

}
